import { Messages } from '../../../codegen/Localize';
import { Module } from '../../../ts/Module';
import { GetServerWelcomeChannelInfoRequest, ServerWelcomeChannelInfo } from '../../../ts/ServerApi/requests/GetServerWelcomeChannelInfoRequest';
import { IUpdateServerWelcomeChannelInfoResult, UpdateServerWelcomeChannelInfoRequest } from '../../../ts/ServerApi/requests/UpdateServerWelcomeChannelInfoRequest';
import { BrowserTitleService } from '../../../ts/services/BrowserTitleService';
import { ServerService } from '../../../ts/services/ServerService';
import { BaseReactSettingsCtrl, BaseReactSettingsCtrlProps, BaseReactSettingsCtrlScope } from '../../controllers/BaseReactSettingsCtrl';
import { SettingsFormService } from '../../directives/tbSettingsCoordinator';

export interface CustomizationSettingsCtrlProps extends BaseReactSettingsCtrlProps {
  sendUpdateRequest: (defaultBannerEnabled: boolean, serverFooter: string) => ng.IPromise<IUpdateServerWelcomeChannelInfoResult>;
  initialServerWelcomeChannelInfo: ServerWelcomeChannelInfo;
}

export class CustomizationSettingsCtrl extends BaseReactSettingsCtrl<CustomizationSettingsCtrlProps> {

  private static formName: string = 'CustomizationSettingsForm';

  public static $inject = [
    '$scope',
    'SettingsFormService',
    'ServerService',
    'BrowserTitleService'
  ];

  constructor(
    $scope: BaseReactSettingsCtrlScope<CustomizationSettingsCtrlProps>,
    formService: SettingsFormService,
    serverService: ServerService,
    browserTitleService: BrowserTitleService
  ) {
    super($scope, formService, serverService, CustomizationSettingsCtrl.formName);

    // Set the tab title
    browserTitleService.setTitleWithTranslatedSpace({translatedSpaceName: Messages.serverSettings_customization()});

    // Setup our one prop
    $scope.props.sendUpdateRequest = this.sendUpdateServerWelcomeChannelInfoRequest.bind(this);

    // Get the initial data from the server
    this.getServerWelcomeChannelInfo().then((result: ServerWelcomeChannelInfo) => {
      $scope.props = {
        ...$scope.props,
        initialServerWelcomeChannelInfo: result
      };
    });
  }

  private getServerWelcomeChannelInfo() {
    return this.serverService.sendRequest(new GetServerWelcomeChannelInfoRequest());
  }

  // Handle API requests outside of our React components
  public sendUpdateServerWelcomeChannelInfoRequest(defaultBannerEnabled: boolean, serverFooter: string): ng.IPromise<IUpdateServerWelcomeChannelInfoResult> {
    return this.serverService.sendRequest(
      new UpdateServerWelcomeChannelInfoRequest({
        welcomeChannelEnabledForServer: defaultBannerEnabled,
        welcomeChannelServerFooter: serverFooter
      })
    );
  }
}

// Remember to register the controller with Angular
Module.instance().controller('CustomizationSettingsCtrl', CustomizationSettingsCtrl);
